export default "__VITE_ASSET__GzOSNrah__"